module.exports = __webpack_public_path__ + "static/media/n8n_io_ai_ex.cbff5606.png";